// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TS6n","title":"styles_title__3Jxeb"};